<template>
	<div class="">
		<login-after-head-search></login-after-head-search>
		<div class="container pb36">
			<div class="pay-title ">
				<router-link to="index">
          首页
        </router-link>
        <span class="arrow"></span>购物车
			</div>

			<div class="fc-bet ">
				<div></div>
				<div class="fc">
<!--					<button type="button" class="btn-defult mgR10" v-if="false">-->
<!--						批量加入报价单-->
<!--					</button>-->
<!--					<button type="button" class="btn-defult" v-if="false">-->
<!--						导出EXCEL-->
<!--					</button>-->
				</div>
			</div>


      <el-dialog  title="发送邮箱" :visible.sync="dialogVisible" width="500px" >
        <el-form ref="form" :model="form" label-width="87px"  >
          <el-input v-model="sendUrl"/>
        </el-form>
        <div style="text-align: right;margin-top: 20px">
          <el-button @click="clickSend" type="primary">发送</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </div>
      </el-dialog>
			<div id="cart-main" v-if="cartList.length">
				<div class="tool-bar">
          <el-button @click="clickCart" type="primary" style="float: right">导出购物车</el-button>
					<div class="row f14 flex" style="overflow: hidden!important;">
						<div class="cell c0">
							<label for="checkBoxAll" class="checkboxStyle" style="margin-right: 5px!important;">
								<input type="checkbox" id="checkBoxAll" :checked="all" @click="selectAll"><span></span>
							</label>
						</div>
						<div class="cell c1 theme w45">全选</div>
						<div class="cell c21 w90 ">序号</div>
						<div class="cell c2 text-center">商品</div>
						<!--<div class="cell c22">箱装数</div>-->
						<div class="cell c3">含税面价</div>
						<div class="cell c4">数量</div>
						<div class="cell c5">合计</div>
            <div class="cell c3">折扣系数</div>
            <div class="cell c3">折扣金额</div>
						<div class="cell c55">总额</div>
						<div class="cell c6">操作</div>
					</div>
				</div>
				<div class="goods" v-if="cartList.length">
					<div class="row myRow flex" v-for="(item,index) in cartList" :key="index">
						<div class="cell c0">
							<label  class="checkboxStyle checkBox1" style="margin-right: 5px!important;" v-if="item.productInfo.unpriced !=1">
								<input type="checkbox" :checked="!!item.selected" @click="select(item)" class="chk chk-all checkBoxFoot"><span></span>
							</label>
						</div>
						<div class="cell c21">{{ index+1 }}</div>
						<div class="cell c1">
              <router-link :to="{path:'details',query:{unique:item.productInfo.attrInfo.unique}}">
								<img :src="item.productInfo.attrInfo.image" v-if="item.productInfo.attrInfo.image" alt=""  style="width: 80px;height: 80px">
								<img :src="item.productInfo.image" v-else-if="item.productInfo.image" alt=""  style="width: 80px;height: 80px">
                <img src="../assets/noll.png" v-else style="width: 80px;height: 80px"/>
							</router-link>
						</div>
						<div class="cell c2">
							<div class="pname">
                <router-link :to="{path:'details',query:{unique:item.productInfo.attrInfo.unique}}">
                  {{ item.productInfo.storeName }}
                </router-link>
								<span class="productCode ">{{ item.productInfo.attrInfo.skuName }}</span>
							</div>
						</div>
						<!--<div class="cell c22 ">90</div>-->
						<div class="cell c3 " v-if="item.productInfo.unpriced ==1">面议</div>
            <div class="cell c3 " v-else >{{ item.vipTruePrice }}</div>
						<div class="cell c4">
							<div class="numbox">
								<button type="button" @click="CartNumDes(index)" style="color: rgb(51, 51, 51); cursor: pointer;">-
								</button>
								<input type="text" v-model="item.cartNum" :data-index="index" @change="changeNumber"
                       oninput="if(value)value=value.replace(/[^0-9]/g,'');if(value>999999)value=999999;if(value.length>6)value=value.slice(0,6);if(value<0)value=0"
                >
								<button type="button" @click="CartNumAdd(index)" style="color: rgb(51, 51, 51); cursor: pointer;">+
								</button>
							</div>
						</div>
            <div class="cell c5"  v-if="item.productInfo.unpriced ==1"><span>面议</span></div>
						<div class="cell c5" v-else><span>{{ (item.vipTruePrice * item.cartNum ).toFixed(2) }}</span></div>
            <div class="cell c3"  v-if="item.productInfo.unpriced ==1">面议</div>
            <div class="cell c3 " v-else>{{ item.discount }}</div>
            <div class="cell c3"  v-if="item.productInfo.unpriced ==1">面议</div>
            <div class="cell c3 "  v-else>{{ (item.discountPrice * item.cartNum ).toFixed(2) }}</div>
            <div class="cell c55"  v-if="item.productInfo.unpriced ==1">面议</div>
						<div class="cell c55 " v-else><span class="f23030 ">￥{{ (item.truePrice * item.cartNum).toFixed(2) }}</span></div>

						<div class="cell c6">
							<a href="javascript:void(0);" v-if="false">加到收藏</a>
							<a href="javascript:void(0);" v-if="false">移入收藏</a>
							<a @click="delCart(item.id,index)">删除</a>
						</div>


					</div>
				</div>

			</div>
			<div id="cart-bar" class="cart-bar-fixed" v-if="cartList.length">

				<ul class="tool">
					<li>
						<label for="checkBoxFoot" class="checkboxStyle" @click="selectAll">
                <input class="chk chk-all checkBoxFoot" type="checkbox" :checked="all">
                <span></span>
						 </label>
						 <span class="theme">全选</span>
					</li>

					<li><a @click="delCarts" >删除选中的商品</a></li>

          <li><a @click="delAllCarts" >清空购物车</a></li>

					<li><a href="javascript:void(0)" v-if="false">移入我的收藏</a></li>
				</ul>
				<ul class="goslmt">
					<li class="cart-totle">数量总计：<span class="f23030">{{ catNums }}个</span></li>
					<li class="cart-totle">
					                    面价金额：<span class="f23030 font-price ">￥{{ costPrice.toFixed(2) }}</span>
					                    <div>
					                        折后金额: <span class="f23030 font-price ">￥{{ totalPrice.toFixed(2)  }}</span>
					                    </div>
					                    <div>
					                        已节省：<span class="">-￥{{ discountPrice.toFixed(2)  }}</span>
					                    </div>
					                    <div>
					                        应付金额: <span class="f23030 font-price ">￥{{ totalPrice.toFixed(2)  }}</span>
					                    </div>
<!--					                    <div>-->
<!--					                        积分消耗合计: <span class="f23030 font-price ">0   积分</span>-->
<!--					                    </div>-->
					                </li>

									<li>
<!--                    <router-link to="tobuy">-->
<!--                      <a href="javascript:void(0)" class="btn f18">去结算</a> </router-link>-->
                    <a :loading="flag" class="btn f18" v-if="dealerLevel===1" @click="toDMC">提交到DMC</a>
                    <a :loading="flag" class="btn f18" v-else @click="sett">去结算</a>
                  </li>

				</ul>
			</div>
<!--      <div class="container pb36" v-else>-->
<!--        暂无购物车商品-->
<!--      </div>-->

      <div id="cart-main" v-else>

        <div class="nothing display-column display-center" >
          <!--        <el-image src="../assets/gzh.png"></el-image>-->
          <div class="tool-bar">
            <div class="row f14 flex" style="overflow: hidden!important;">
              <div class="cell c0">
                <label for="checkBoxAll" class="checkboxStyle" style="margin-right: 5px!important;">
                  <input type="checkbox" id="checkBoxAll" :checked="all" @click="selectAll"><span></span>
                </label>
              </div>
              <div class="cell c1 theme w45">全选</div>
              <div class="cell c21 w90 ">序号</div>
              <div class="cell c2 text-center">商品</div>
              <!--<div class="cell c22">箱装数</div>-->
              <div class="cell c3">含税面价</div>
              <div class="cell c4">数量</div>
              <div class="cell c5">合计</div>
              <div class="cell c23">折扣</div>
              <div class="cell c55">总额</div>
              <div class="cell c6">操作</div>
            </div>
          </div>
          <img  class="nocart" width="80px" height="80px" src="../assets/nocart.png">
          <p class="fs18 mar-top-20">暂无数据哦～</p>
        </div>
      </div>

		</div>



		<i-toast ref="toast">
			删除成功
		</i-toast>
		<i-footer></i-footer>
		<fixed-right></fixed-right>
	</div>
</template>

<script>
import {
  cartCount,
  cartList,
  cartUpdate,
  cartDel, sendCartList
} from '@/api/cart'
import {
  cartInitialDistributors
} from '@/api/order'
import { getToken } from '@/axios/cookies'
import { clearUserInfo, getStoredUserInfo, hasUserIdentity } from '@/utils/auth'
import { mapGetters, mapMutations } from 'vuex'
	export default {

		data() {
			return {
        sendUrl: '',
        dialogVisible: false,
        all: false,
        check: false,
        num: 1,
        catNums: 0,
        flag: false,
        cartList: [],
        invalidGoods: [],
        totalPrice: 0,
        discountPrice: 0,
        costPrice: 0,
        postage: 0,
        loading: false,
        noGoods: false,
        cartId: null,
        dealerLevel: 2,
			}
		},
		mounted() {
      const userInfo = hasUserIdentity(this.userInfo) ? this.userInfo : getStoredUserInfo()
      if (!getToken() || !hasUserIdentity(userInfo)) {
        clearUserInfo()
        this.$router.replace('/login')
        return
      }
      this.dealerLevel = Number(userInfo.dealerLevel) === 1 ? 1 : 2
      console.log('购物车用户信息', userInfo)
      this.getCartList()
      this.getCartNum()
		},
    computed: {
      ...mapGetters([
        'cartNum', // 购物车商品数量
        'userInfo'
      ])
    },
		methods: {
      clickCart(){
        this.dialogVisible=true
      },
      clickSend(){
        console.log('发送邮箱',this.sendUrl)
        this.$message.success('发送成功')
        this.dialogVisible=false
        sendCartList({to:this.sendUrl}).then(res=>{
          console.log(res)
        })
      },
      ...mapMutations({
        setCartNum: 'SET_CARTNUM' // 修改vuex购物车数量
      }),
      // 获取购物车商品数量
      async getCartNum () {
        var res = await cartCount()
        if (res.status === 200) {
          this.setCartNum(res.data.count)
        } else {
          this.$message.warning(res.msg)
        }
      },
      // 获取购物车列表
      async getCartList () {
        this.loading = true
        const res = await cartList()
        if (res.status === 200) {
          this.cartList = res.data.valid
          this.invalidGoods = res.data.invalid
          this.totalPrice = 0
          this.postage = 0
          this.noGoods = (this.invalidGoods.length === 0 && this.cartList.length === 0)
          this.cartList.forEach(i => {
            this.$set(i, 'selected', false)
          })
        } else {
          this.$message.warning(res.msg)
        }
        this.loading = false
      },
      // 跳转到商品详情
      toDetail (id) {
        this.$router.push({
          path: '/productDetail',
          query: {
            productId: id
          }
        })
      },
      // 全选
      selectAll () {
        this.all = !this.all
        this.cartList.forEach(i => {
          if (i.productInfo.unpriced !=1) {
            i.selected = this.all;    
          }          
        })
        this.computePrice()
      },

      // 单选
      select (item) {
        item.selected = !item.selected
        this.all = true
        this.cartList.forEach(i => {
          if (!i.selected) {
            this.all = false
          }
        })
        this.computePrice()
      },

      // 计算价格
      computePrice () {
        this.totalPrice = 0
        this.discountPrice = 0
        this.costPrice = 0
        this.postage = 0
        this.catNums = 0
        this.cartList.forEach(i => {
          if (i.selected) {
            this.totalPrice = (this.totalPrice + i.cartNum * Number(i.truePrice))
            this.discountPrice = (this.discountPrice + i.cartNum * Number(i.discountPrice))
            this.costPrice = (this.costPrice + i.cartNum * Number(i.costPrice))
            this.catNums += i.cartNum
          }
        })
        if (this.catNums){
          let catNumsStr = this.catNums+''
          if (catNumsStr[0] == '0'){
            catNumsStr = catNumsStr.substring(1,catNumsStr.length)
            console.log('当前数量',catNumsStr)
            this.catNums = Number.parseInt(catNumsStr)
          }
        }
      },

      // 修改商品数量
      handleChange (id, num) {
        cartUpdate({
          id: id,
          number: num
        }).then(res => {
          if (res.status === 200) {
            this.computePrice()
          } else {
            this.$message.warning(res.msg)
          }
        })
      },
      CartNumDes(index) {
        if (this.cartList[index].cartNum === 1) {
          return;
        } else {
          //修改商品数量
          console.log("else")
          console.log(this.cartList[index].cartNum)
          this.cartList[index].cartNum--;
          this.updateCartNum(this.cartList[index].id, this.cartList[index].cartNum)
        }
      },
      CartNumAdd(index) {
        // if (this.cartList[index].cartNum == this.cartList[index].productInfo.stock) {
        //   this.updateCartNum(this.cartList[index].id, this.cartList[index].cartNum)
        //   return;
        // } else {
          this.cartList[index].cartNum++;
          //修改商品数量
          this.updateCartNum(this.cartList[index].id, this.cartList[index].cartNum)
        // }
      },
      changeNumber(e) {
        const that = this;
        let index = e.target.dataset.index;

        if (e.target.value == 0) {
          that.cartList[index].cartNum = 1;
          //修改商品数量
          that.updateCartNum(that.cartList[index].id, that.cartList[index].cartNum)
        } else {
          // that.cartProductList[index].cartNum++;
          //修改商品数量
          that.updateCartNum(that.cartList[index].id, that.cartList[index].cartNum)
        }

      },
      updateCartNum(id, cartNum) {
        let that=this;
        let data = {
          id: id,
          number: cartNum
        }
        cartUpdate(data).then(res => {
          if (res.status === 200) {
            this.computePrice()
          } else {
            this.$message.warning(res.msg)
          }
        })
      },
      // 删除请求
      del (ids) {
        console.log('删除购物车产品', ids)
        cartDel({ 'ids': ids }).then(res => {
          if (res.status === 200) {
            this.$message.success('删除成功')
            //this.getCartList()
            this.computePrice()
            this.getCartNum()
          } else {
            this.$message.warning(res.msg)
          }
        })
      },
      // 删除购物车商品
      delCart (id,index) {
        this.$confirm('确定删除该商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.cartList.splice(index,1)
          this.del([id])
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }).finally(() => {
          // this.getCartList();
        })
      },

      // 批量删除
      delCarts () {
        let ids = []
        this.cartList.forEach(i => {
          if (i.selected) {
            ids.push(i.id)
          }
        })
        if (ids.length === 0) {
          return this.$message.warning('请先选择需要删除的商品')
        }
        this.$confirm('确定删除选中的商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(ids)
          this.all = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }).finally(() => {
          //this.getCartList();
        })

      },
      // 清空购物车
      delAllCarts () {
        let ids = []
        this.cartList.forEach(i => {
          //if (i.selected) {
            ids.push(i.id)
          //}
        })
        if (ids.length === 0) {
          return this.$message.warning('请先选择需要删除的商品')
        }
        this.$confirm('确定删除所有的商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(ids)
          this.all = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }).finally(() => {
          //this.getCartList();
        })

      },
      // 结算
      sett () {
        let ids = []
        this.cartList.forEach(i => {
          if (i.selected) {
            ids.push(i.id)
          }
        })
        if (ids.length === 0) {
          return this.$message.warning('请选择需要结算的商品')
        }
        this.flag = true
        ids = ids.join(',')
        this.$router.push({
          path: '/tobuy',
          query: {
            cartId: ids
          }
        })
      },
      // 结算 toDMC
      toDMC () {
        let ids = []
        this.cartList.forEach(i => {
          if (i.selected) {
            ids.push(i.id)
          }
        })
        if (ids.length === 0) {
          return this.$message.warning('请选择需要结算的商品')
        }
        this.flag = true
        ids = ids.join(',')
        // this.$router.push({
        //   path: '/order/cartInitialDistributors',
        //   query: {
        //     cartId: ids
        //   }
        // })
        var data = {
          cartId: ids
        }
        cartInitialDistributors(data).then(res => {
          console.log("res===》》》", res)
          if (res.data.result) {
            this.$message.success('提交到DMC成功')
            this.getCartList()
            this.flag = false
          }
        }).catch(err => {
          return this.$message.warning(err.msg)   
          this.flag = false       
        })
      },
			del1(){
				this.$refs.toast.open()
			}
		},


	}
</script>

<style scoped lang="less">
.nothing{
  padding: 80px 0;
  img{
    width: 150px;
    height: 130px;
  }
}


.nocart{margin-top:1cm;}

.display-column{display: flex;flex-direction: column;}

.display-center{display: flex;justify-content: center;align-items: center;}
</style>
